import { render, staticRenderFns } from "./EventsMenu.vue?vue&type=template&id=ebd492ba&scoped=true&"
import script from "./EventsMenu.vue?vue&type=script&lang=ts&"
export * from "./EventsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./EventsMenu.vue?vue&type=style&index=0&id=ebd492ba&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd492ba",
  null
  
)

export default component.exports